import Image from '@tiptap/extension-image'
import {customImage} from './custom-image';
import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from 'prosemirror-state'
import { getClipboardBase64Image } from './get-clipboard-base64-image'
import { resizeImage } from './resize-image'
import { browserImageReader } from './browser-image-reader';

export const CustomImageExtension = customImage.extend({
  //group: 'block',
  //content: 'inline*',

  addProseMirrorPlugins() {
    let editor = this.editor;
    let {
      resizeMaxHeight,
      resizeMaxWidth,
      imageReader
    } = this.options;

    if(!imageReader) {
      imageReader = browserImageReader
    }

    //sets the image to the editor view
    const setImageToView = (schema, view, src, coordinates) => {
      const editor = this.editor;

      console.log('setting image');

      editor.commands.setImage({
        src,
        alt: 'uploading',
        uploading: true
      });
    };

    async function processFile(file, schema, view, coordinates) {
      //get base64 image from reader
      const img = await imageReader(file);

      //resize the image
      const src = await resizeImage(img, resizeMaxWidth, resizeMaxHeight);

      setImageToView(schema, view, src, coordinates);
    }

    return [
      new Plugin({
        key: new PluginKey('eventHandler'),
        props: {
          handleDOMEvents: {
            drop(view, event, slice) {
              const items = event.dataTransfer.files
              const { schema } = view.state

              if(!items.length) {
                return;
              }

              for(let i = 0; i < items.length; i++) {
                const file = items[i];
                const coordinates = view.posAtCoords({
                  left: event.clientX,
                  top: event.clientY
                });

                if(file.type.indexOf("image") == -1) {
                  continue;
                }

                processFile(file, schema, view, coordinates);
              }
            },

            paste(view, event, slice) {
              const items = event.clipboardData.items;
              const { schema } = view.state;

              let images = [];

              if(!items.length) {
                return;
              }

              for(let i = 0; i < items.length; i++) {
                let item = items[i];
                let type = item.type;

                // skip to next item
                if(item.type.indexOf("image") == -1) {
                  continue;
                }

                const file = item.getAsFile();

                //set image file to editor view
                processFile(file, schema, view);
              }
            },

            // Here is the full list: https://prosemirror.net/docs/ref/#view.EditorProps
          }
        },
      }),
    ]
  },
})